import React, { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function PhoneGate() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const bodyOverflow = document.body.style.overflow;
    const root = document.getElementById('root');
    const rootOverflow = root?.style.overflow;
    document.body.style.overflow = 'auto';
    if (root) root.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = bodyOverflow;
      if (root) root.style.overflow = rootOverflow;
    };
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    setMessage('');
    const params = new URLSearchParams(window.location.search);
    const payload = { email };
    if (window.location.pathname === '/workshop' && params.get('event')) payload.event = params.get('event');
    try {
      const response = await fetch(`${BACKEND_URL}/api/v1/platform/send-link`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.detail || 'Unable to send the email.');
      setMessage('Sent! Open it on a laptop or tablet.');
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSending(false);
    }
  };

  return <main style={{ minHeight: '100vh', overflowX: 'hidden', padding: '32px 20px', background: '#0A0A0A', color: '#fff', display: 'grid', placeItems: 'center', fontFamily: "'Barlow', 'Inter', sans-serif" }}>
    <section style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>
      <img src="/pizzul/happy.png" alt="Happy Pizzul" style={{ width: 112, height: 112, objectFit: 'contain', margin: '0 auto 20px' }} />
      <h1 style={{ fontSize: 28, lineHeight: 1.15, margin: '0 0 14px', fontWeight: 700 }}>Beat Arranger is built for laptops and tablets</h1>
      <p style={{ color: '#d0d0d0', fontSize: 16, lineHeight: 1.5, margin: '0 0 24px' }}>Grab a laptop or tablet to make your beat. Want the link? We&apos;ll email it to a grown-up.</p>
      <form onSubmit={submit} style={{ textAlign: 'left', background: '#1A1A1A', padding: 20, borderRadius: 16, border: '1px solid #3a3a3a' }}>
        <label htmlFor="phone-gate-email" style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>Grown-up&apos;s email address</label>
        <input id="phone-gate-email" type="email" required value={email} onChange={(event) => setEmail(event.target.value)} style={{ width: '100%', minWidth: 0, padding: '12px', borderRadius: 8, border: '1px solid #777', color: '#111', fontSize: 16 }} />
        <button type="submit" disabled={sending} style={{ width: '100%', marginTop: 16, border: 0, borderRadius: 24, padding: '13px 16px', background: '#00D4AA', color: '#07110f', fontWeight: 700, fontSize: 16, cursor: sending ? 'wait' : 'pointer' }}>{sending ? 'Sending...' : 'Email me the link'}</button>
        {message && <p role="status" style={{ color: message.startsWith('Sent!') ? '#71e7cc' : '#ff93b8', margin: '14px 0 0', textAlign: 'center', lineHeight: 1.4 }}>{message}</p>}
      </form>
      <a href="https://letthebeatbuild.me" style={{ display: 'inline-block', marginTop: 24, color: '#73ead0', fontWeight: 600 }}>Learn about LTBB programs</a>
    </section>
  </main>;
}

export default PhoneGate;
